import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import Layout from '@/components/layout/LayoutWrapper';
import EnTermsMDX from '@/markdown/terms/gift-terms/en.mdx';
import { Locale } from '@/store/locale/types';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

interface LocaleMdxProps {}

/*
 * Need to use switch statement due to need for static strings in `import` function within `dynamic()`
 * https://nextjs.org/docs/advanced-features/dynamic-import
 * This might eventually get fixed: https://github.com/vercel/next.js/discussions/33980
 */
const localeMdx = (locale: Locale = 'en') => {
	const defaultMDX = EnTermsMDX;

	switch (locale) {
		case 'fr':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/fr.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'ja':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/ja.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'es':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/es.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'de':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/de.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'pt':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/pt.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'ko':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/ko.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'it':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/it.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'pl':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/pl.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		case 'zh':
			return dynamic<LocaleMdxProps>(() =>
				import('@/markdown/terms/gift-terms/zh.mdx').then(mdx => mdx).catch(() => defaultMDX),
			);
		// English fallback
		case 'en':
		default:
			return defaultMDX;
	}
};

const GiftTerms = ({ initialState: { locale } }: { initialState: { locale: Locale } }) => {
	const LocaleMdx = localeMdx(locale);

	// TODO: refactor this code to follow best practices
	/* eslint-disable react-hooks/static-components */
	return (
		<Layout pageName="gift-terms" title="Calm - Gift Card Terms and Conditions">
			<LocaleMdx />
		</Layout>
	);
	/* eslint-enable react-hooks/static-components */
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
			hideAcceptCookiesModal: true,
		},
	};
};

export default GiftTerms;
